import FeatureSwitchCheck from "./FeatureSwitchCheck";
import { UserType } from "types/Users";


export default abstract class NumberAboveOrEqualsFeatureSwitchCheck extends FeatureSwitchCheck<number | undefined, [ UserType | null | undefined ]> {

  protected abstract getUserProperty(user: UserType | null | undefined): number | undefined;


  protected doCheck(featureValue: number | undefined, user: UserType | null | undefined): boolean {
    if (!featureValue) {
      return false;
    }

    const userProperty = this.getUserProperty(user);
    if (!userProperty) {
      return false;
    }

    return userProperty >= featureValue;
  }

}
